//@flow
/**
 * Client reducer
 * @module client/reducer
 */
import { Record, List } from "immutable";

export const FETCH_COURSE_REQUEST = "FETCH_COURSE_REQUEST";
export const FETCH_COURSE_PENDING = "FETCH_COURSE_PENDING";
export const FETCH_COURSE_SUCCESS = "FETCH_COURSE_SUCCESS";
export const FETCH_COURSE_FAILURE = "FETCH_COURSE_FAILURE";

export type Action =
  | { type: "FETCH_COURSES" }
  | { type: "FETCH_COURSE_PENDING", payload: ?CoursePublic }
  | { type: "FETCH_COURSE_SUCCESS", payload: CoursePublic }
  | { type: "FETCH_COURSE_FAILURE", payload: Error, error: true };

const CoursesRecord = Record({
  loading: false,
  courses: List(),
  error: null
});

/**
 * Handles storing and fetching of client data.
 * @memberof course/reducer
 */
function ClientReducer(
  state: CoursesRecord = new CoursesRecord(),
  action: Action
): CoursesRecord {
  switch (action.type) {
    case FETCH_COURSE_REQUEST:
      return state.set("loading", true);

    case FETCH_COURSE_PENDING:
      if (action.payload != null) {
        return state.set("loading", false).merge({courses: action.payload });
      }
      return state;

    case FETCH_COURSE_SUCCESS:
      return state.set("loading", false).merge({courses: action.payload });

    case FETCH_COURSE_FAILURE:
      return state.set("loading", false).set("error", action.payload);

    default:
      return state;
  }
}

export default ClientReducer;



// WEBPACK FOOTER //
// ./src/state/courses/reducer.js